import { BlockTransformContext, StoryblokBlock } from '~/lib/storyblok'

export async function transformChefsSelectionBlock(block: StoryblokBlock, { props, options }: BlockTransformContext) {
  return {
    ...props,
    title: block.title,
    richtext: block.richtext,
    chefs: block.chefs,
    options: {
      ...options,
      order: block.option_order || 'text_image',
    },
  }
}
